<template>
    <div class="section">
        
        <transition
            enter-active-class="animated fadeInRight"
            leave-active-class="animated fadeOutLeft"
            mode="out-in"
        >
            
            <div v-if="!sessionCompleted" class="columns is-centered">
                <div class="is-6">
                    <transition
                        enter-active-class="animated fadeInRight"
                        leave-active-class="animated fadeOutLeft"
                        mode="out-in"
                    >
                        <div :key="riddle._id" class="is-relative">
                            <div class="lb-question-games">
                                <div
                                    class="
                                        is-relative
                                        lb-question-container
                                        pt-6
                                    "
                                >
                                    <session-object-card
                                        ref="questionCard"
                                        :time-limit="0"
                                        :time-units="'seconds'"
                                        :content="riddle"
                                        @answer="registerAnswer"
                                    >
                                        <div
                                            v-if="
                                                trigger &&
                                                trigger == 'AT_ARRIVE'
                                            "
                                        >
                                            <div :key="riddle._id" class="pt-3">
                                                <session-map
                                                    v-model="location"
                                                    :target-location="
                                                        riddle.location
                                                    "
                                                    :bounds="gameBounds"
                                                    :center="gameCenter"
                                                />
                                            </div>
                                        </div>
                                        <nav class="level is-mobile">
                                            <div class="level-left"></div>
                                            <div class="level-item">
                                                <progress
                                                    v-if="!done"
                                                    :value="progress"
                                                    class="progress is-info"
                                                    max="100"
                                                >
                                                    {{ progress }}%
                                                </progress>
                                                <a
                                                    v-if="done"
                                                    v-t="
                                                        session.simulation
                                                            ? `Buttons.close`
                                                            : `Sessions.triggers.done`
                                                    "
                                                    class="button is-primary"
                                                    @click="showResume"
                                                ></a>
                                            </div>
                                            <div
                                                v-if="
                                                    trigger && trigger == 'NEXT'
                                                "
                                                class="level-right"
                                            >
                                                <a
                                                    v-t="
                                                        `Sessions.triggers.${trigger}`
                                                    "
                                                    class="button is-primary"
                                                    @click="
                                                        registerAnswer({
                                                            trigger,
                                                        })
                                                    "
                                                ></a>
                                            </div>
                                        </nav>
                                    </session-object-card>
                                    <play-score-viewer
                                        v-if="!session.simulation"
                                        :score="score"
                                        :ranking="rankingInfo"
                                        :questions="questionsInfo"
                                        class="lb-score-play"
                                    />
                                    <!--<transition
                                        enter-active-class="animated fadeInRight"
                                        leave-active-class="animated fadeOutLeft"
                                        mode="out-in"
                                    >
                                        <div v-if="riddle.location" :key="riddle._id" class="pt-3">
                                            <session-map
                                                v-model="location"
                                                :target-location="riddle.location"
                                                :bounds="gameBounds"
                                                :center="gameCenter"
                                            />
                                        </div>
                                    </transition>-->
                                    <app-animation
                                        v-if="showAnimation"
                                        :animation="animation"
                                    />
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
            <session-end-resume
                v-else-if="!session.simulation"
                :score="score"
            />
        </transition>
        
    </div>
</template>

<script>
import SessionObjectCard from '@/components/SessionObjectCard';
import AppAnimation from '@/components/AppAnimation';
import SessionMap from '@/components/SessionMap';
import SessionEndResume from '@/components/SessionEndResume';
import { getDistance, getBounds, getCenterOfBounds } from 'geolib';
import _ from 'underscore';
import { sendAnswer, getUserRankingPosition } from '@/services/API';
//import { Treasurehunt } from '@labygram/treasurehunt';
import PlayScoreViewer from '@/components/PlayScoreViewer';
export default {
    components: {
        SessionObjectCard,
        SessionMap,
        SessionEndResume,
        AppAnimation,
        PlayScoreViewer,
    },
    data() {
        return {
            score: 0,
            location: undefined,
            animation: undefined,
            sessionCompleted: false,
            showAnimation: false,
            showConfettiAnimation: false,
            done: false,
            activeItem: {},
            classMachine: {},
            progress: 0,
            rankingInfo: {
                position: 0,
                users: 0,
            },
            currentSessionAnsweredQuestions: [],
        };
    },
    computed: {
        riddle() {
            return this.activeItem;
        },
        trigger() {
            /*console.log(
                'trigger',
                this.riddle.triggers && _.keys(this.riddle.triggers)[0]
            );*/
            if (this.riddle.triggers[_.keys(this.riddle.triggers)[0]] == '') {
                return 'END';
            }
            return this.riddle.triggers && _.keys(this.riddle.triggers)[0];
        },
        session() {
            return this.$store.state.session;
        },
        gameBounds() {
            return getBounds([this.riddle.location]);
        },
        gameCenter() {
            return getCenterOfBounds([this.riddle.location]);
        },
        distance() {
            return (
                this.riddle.location &&
                this.location &&
                getDistance(this.location, this.riddle.location, 10)
            );
        },
        questions() {
            const totalQuestions = _.filter(
                this.session.context,
                (question) => {
                    return question.type == 'question';
                }
            );
            return totalQuestions;
        },
        answeredQuestions() {
            return [
                ...this.currentSessionAnsweredQuestions,
                ..._.pluck(
                    _.pluck(this.session.session_answers, 'object'),
                    '_id'
                ),
            ];
        },
        questionsInfo() {
            return {
                answered: this.answeredQuestions.length,
                total: this.questions.length,
            };
        },
    },
    watch: {
        distance: {
            handler() {
                if (this.distance < 50) {
                    this.registerAnswer({
                        answer: {
                            answer: { value: this.location },
                            object: this.riddle._id,
                            time: new Date() - this.$refs.questionCard.time,
                            points: 10,
                        },
                        trigger: 'AT_ARRIVE',
                    });
                    this.location = {};
                }
            },
        },
    },
    beforeMount() {
        this.classMachine = new Treasurehunt(this.session.context);
        this.classMachine.on('update', this.updateItem);
        this.classMachine.on('done', this.finishGame);
        this.start();
    },
    mounted() {
        if (!this.session.simulation) {
            // no need to get user score in simulated session
            getUserRankingPosition(this.session._id).then(({ data }) => {
                this.rankingInfo.users = data.totalUsers;
                this.rankingInfo.position = data.totalUsers;
                this.score = data.score;
            });
        }
    },
    beforeDestroy() {
        this.classMachine.off('update', this.updateItem);
        this.classMachine.off('done', this.finishGame);
    },
    methods: {
        start() {
            this.classMachine.play();
        },
        updateItem({ activeItem }) {
            this.activeItem = activeItem;
            // console.log(this.activeItem);
            this.progress = this.classMachine.progress;
        },
        finishGame() {
            this.done = true;
        },
        findModel({ _id }) {
            return _.findWhere(this.session.context, {
                _id,
            });
        },
        async registerAnswer({ answer, trigger }) {
            this.$emit('answer', answer);
            if (answer) {
                if (answer.points > 0) {
                    this.animation = require('@/assets/animations/checkmark.json');
                    this.showConfettiAnimation = true;
                } else {
                    this.animation = require('@/assets/animations/error.json');
                }
                this.showAnimation = true;
                setTimeout(() => {
                    this.showAnimation = false;
                    this.showConfettiAnimation = false;
                    this.classMachine.send(trigger);
                    this.currentSessionAnsweredQuestions.push(answer.object);
                }, 2000);

                if (this.session.simulation) {
                    return;
                }
                await sendAnswer(this.$store.state.session._id, {
                    ...answer,
                    project: this.$store.state.session.project,
                });
                let position = await getUserRankingPosition(this.session._id);
                this.rankingInfo.users = position.data.totalUsers;
                this.rankingInfo.position = position.data.totalUsers;
                this.score = position.data.score;
            } else {
                setTimeout(() => {
                    this.classMachine.send(trigger);
                }, 0);
            }
        },
        showResume() {
            this.sessionCompleted = true;
            this.$emit('close');
        },
    },
};
</script>

<style scoped>
.lb-question-game {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    margin: auto;
}
.lb-score-play {
    position: absolute !important;
    margin: auto;
    top: 0%;
    left: 0;
    right: 0;
}
.progress {
    border-radius: 0;
    height: 0.4rem;
}
</style>
